<!-- index oferta -->
  <template>
    <div class="xcard oferta-wrap">
      <v-card class="oferta-hero elevation-2">
        <v-card-text class="d-flex align-center justify-space-between">
          <div class="d-flex align-center" style="gap: 12px;">
            <v-avatar color="white" size="44" class="elevation-1">
              <v-icon color="teal darken-3">mdi-school-outline</v-icon>
            </v-avatar>
            <div>
              <div class="text-h6 white--text">Gestión de oferta académica</div>
              <div class="text-body-2 white--text">
                Selecciona, revisa y publica programas de forma centralizada
              </div>
            </div>
          </div>
          <v-chip color="teal lighten-5" class="teal--text text--darken-3" small>
            Institucional
          </v-chip>
        </v-card-text>
      </v-card>

      <div v-show="false">
        <div class="section-title">Flujo académico (nuevo)</div>
        <div class="section-subtitle">Estas opciones reemplazan el flujo anterior y mantienen consistencia institucional.</div>
        <v-row dense>
          <v-col cols="12" md="4" >
            <v-card class="action-card" outlined @click="open_modal_escoger()" v-if="ispermitido_escoger">
              <v-card-title class="text-subtitle-1">
                <v-icon left color="teal darken-2">mdi-book-open-variant</v-icon>
                Escoger programas universidad
              </v-card-title>
              <v-card-subtitle>Selecciona programas a nivel nacional para la oferta.</v-card-subtitle>
            </v-card>
          </v-col>
          <v-col cols="12" md="4">
            <v-card class="action-card" outlined @click="open_modal_ver_escogidos()" v-if="ispermitido_regular">
              <v-card-title class="text-subtitle-1">
                <v-icon left color="teal darken-2">mdi-clipboard-check-outline</v-icon>
                Ver programas escogidos
              </v-card-title>
              <v-card-subtitle>Asigna sedes y confirma los programas aprobados.</v-card-subtitle>
            </v-card>
          </v-col>
          <v-col cols="12" md="4">
            <v-card class="action-card" outlined @click="open_modal_ver_aprobados()" v-if="ispermitido_crearprogramas">
              <v-card-title class="text-subtitle-1">
                <v-icon left color="teal darken-2">mdi-school</v-icon>
                Ver programas aprobados
              </v-card-title>
              <v-card-subtitle>Crea programas desde la oferta ya aprobada.</v-card-subtitle>
            </v-card>
          </v-col>
        </v-row>
        <v-divider class="my-14"></v-divider>
      </div>


      <div class="section-title">Acciones administrativas (legacy)</div>
      <div class="section-subtitle">Opciones del flujo anterior. Úsalas solo si es necesario.</div>
      <v-row dense>
        <v-col cols="12" sm="6" md="3" v-if="ispermitido">
          <v-card class="legacy-card" outlined @click="reporteOpen('oferta_autoria_sel')">
            <v-card-title class="text-subtitle-2">Seleccionar proyectos</v-card-title>
            <v-card-subtitle>Solicitar apertura de programas.</v-card-subtitle>
          </v-card>
        </v-col>
        <v-col cols="12" sm="6" md="3" v-if="ispermitido_regular">
          <v-card class="legacy-card" outlined @click="reporteOpen('oferta_autoria')">
            <v-card-title class="text-subtitle-2">Gestionar</v-card-title>
            <v-card-subtitle>Aprobar y/o rechazar seleccionados.</v-card-subtitle>
          </v-card>
        </v-col>
        <v-col cols="12" sm="6" md="3" v-if="ispermitido_regular">
          <v-card class="legacy-card" outlined @click="ofertaOpen()">
            <v-card-title class="text-subtitle-2">Lista oficial</v-card-title>
            <v-card-subtitle>Publicación de la lista oficial.</v-card-subtitle>
          </v-card>
        </v-col>
        <v-col cols="12" sm="6" md="3" v-if="ispermitido_regular">
          <v-card class="legacy-card" outlined @click="reporteOpen('oferta_regularizar')">
            <v-card-title class="text-subtitle-2">Regularizar manual</v-card-title>
            <v-card-subtitle>Visibilidad y estado en oferta.</v-card-subtitle>
          </v-card>
        </v-col>
      </v-row>

      <modal-escoger ref="modalEscoger" />
      <modal-verescogidos ref="modalVerEscogidos" />
      <modal-verAprobados ref="modalVerAprobados" />
    </div>
  </template>
  
  <script>
  import modalEscoger from './uno_general/modal-escoger.vue';
  import modalVerescogidos from './uno_general/modal-ver_escogidos.vue';
  import modalVerAprobados from './uno_general/modal-ver_aprobados.vue';

    export default {
      data() {
        return {
          estudiantes: [],
          ispermitido_general: false,
          ispermitido_regular: false,
          ispermitido_escoger: false,
          ispermitido_crearprogramas: false,
          ispermitido: false,
        };
      },
      watch: {},
      components: {modalEscoger,modalVerescogidos,modalVerAprobados},
      methods: {
        ofertaOpen() {
          const u = this.$store.state.CARGO.sede.unidad_negocio; 
          
          if(u == 1) this.$router.push({ name: 'oferta_oficial_esam' });
          else this.$router.push({ name: 'oferta_oficial_dbs' });
        },
        reporteOpen(url) {
          this.$router.push({ name: url });
        },
        openlink(url) {
          window.location.href = url;
        },
        open_modal_escoger() {
          this.$refs.modalEscoger.openmodal();
        },
        open_modal_ver_escogidos() {
          this.$refs.modalVerEscogidos.openmodal();
        },
        open_modal_ver_aprobados() {
          this.$refs.modalVerAprobados.openmodal();
        }
      },
      mounted() {
        this.ispermitido_general = this.$store.state.CARGO.id == 1 || this.$store.state.CARGO.id == 2 || this.$store.state.CARGO.id == 3 || this.$store.state.CARGO.id == 5;
        this.ispermitido = this.$store.state.CARGO.id == 1 || this.$store.state.CARGO.id == 2 || this.$store.state.CARGO.id == 3 || this.$store.state.CARGO.id == 5 || this.$store.state.CARGO.id == 6 || this.$store.state.CARGO.id == 7 || this.$store.state.CARGO.id == 8 || this.$store.state.CARGO.id == 11 || this.$store.state.CARGO.id == 12 || this.$store.state.CARGO.id == 13;
        this.ispermitido_escoger = this.$store.state.CARGO.id == 1 || this.$store.state.CARGO.id == 26;
        this.ispermitido_regular = this.$store.state.CARGO.id == 1 || this.$store.state.CARGO.id == 5 || this.$store.state.CARGO.id == 6;
        this.ispermitido_crearprogramas = this.$store.state.CARGO.id == 1 || this.$store.state.CARGO.id == 5 || this.$store.state.CARGO.id == 26;
      },
    };
  </script>

  <style scoped>
  .oferta-wrap {
    padding: 12px;
  }
  .oferta-hero {
    border-radius: 16px;
    background: linear-gradient(120deg, #004D40 0%, #00796B 45%, #4DB6AC 100%);
    margin-bottom: 16px;
  }
  .section-title {
    font-weight: 600;
    margin: 6px 0 2px;
  }
  .section-subtitle {
    color: #607d8b;
    margin-bottom: 10px;
  }
  .action-card {
    border-radius: 12px;
    transition: box-shadow 0.2s ease, transform 0.2s ease;
  }
  .action-card:hover {
    box-shadow: 0 8px 18px rgba(0, 0, 0, 0.12);
    transform: translateY(-2px);
  }
  .legacy-card {
    border-radius: 10px;
    background: #fafafa;
  }
  </style>
  
